import { Http } from "../constants";
import { appConfig } from "../configs";
import axios, {
  AxiosError,
  AxiosInstance,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import { authHelper } from "../helpers";

const axiosConfig: AxiosInstance = axios.create({
  baseURL: appConfig.API_URL,
});


axiosConfig.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const access_token = authHelper.accessToken();
    if (access_token && config.headers) {
      config.headers.Authorization = `Bearer ${access_token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosConfig.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    const { response } = error;
    if (response && response?.status !== Http.SUCCESS_CODE) {
      if (response?.status === Http.AUTHENTICATION_FAIL_CODE) {
        console.log("401 err");
      }
      return Promise.reject(response);
    }
    return Promise.reject(response);
  }
);

export default axiosConfig;
